export const API_BASE = "https://tdd.demo.reaktivate.com/v1/books/borodean";
